import React from 'react';
import _ from 'lodash';

export default function  Compare() {
  return (
    <div>Compare</div>
  )
}